import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
export type CreateWorkflowRequestData = {
  key: string;
  name: string;
  project_id: string;
  steps: {
    id: string;
    table_key: string;
    // OG name or override
    name: string;
    version: number;
  }[];
  results: {
    // Concatenation of result key and source table ID—key
    id: string;
    output_policy: "KEEP" | "DISCARD";
    intermediate: boolean;
  }[];
  inputs: {
    id: string;
    intermediate: boolean;
  }[];
  // used for populating workflows from schema later in the absence of tables
  edges: { source: string; target: string }[];
  source_tables: {
    kind: "data_table" | "gdt_analysis_table";
    id: string;
  }[];
  param_map: {
    param: string;
    column: {
      id: string;
      kind: "data_table_column" | "gdt_analysis_table_column";
    };
    // The ID of the step (e.g., 'DOW')
    step: string;
  }[];
};
export const workflowCreate = djangoClientQueryFactory(
  {
    method: "post",
    path: "/wrs/workflow/create_from_tables/",
  },
  {
    formatInput: (input: CreateWorkflowRequestData) => {
      return {
        body: {
          key: input.key,
          name: input.name,
          project: input.project_id,
          edges: input.edges,
          results: input.results,
          steps: input.steps,
          inputs: input.inputs,
          source_tables: input.source_tables,
          param_map: input.param_map,
        },
      };
    },
    handleResponse: (res) => {
      assert(res.data !== undefined);
      return res.data;
    },
  },
);
